module.exports = __webpack_public_path__ + "static/media/premium.f9b04f74.svg";